import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, throwError, empty } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DefaultFilter, DefaultServiceInterface } from './../../../core/framework/default-service.interface';
import { ErrorHandlerService } from './../../../core/framework/error-handler.service';
import { ItemInventarioResumido } from './item-inventario-resumido.model';
import { ListaComponent } from './../../../core/list/lista.component';
import { ListaResultset } from './../../../core/list/lista-resultset.interface';
import { DefaultService } from 'src/app/core/framework/default-service';
import { ItemInventario } from './item-inventario.model';
import { ItemInventarioFilter } from '../componentes/seletor-de-lote/model/item-inventario.filter';
import { Inventario, InventarioDTO } from '../inventario/inventario.model';


// export interface ItemInventarioFilter extends DefaultFilter {
//     idLote?: number;
//     idInventario?: number;
// }

@Injectable()
export class ItemInventarioService extends DefaultServiceInterface {

    constructor(
        private httpClient: HttpClient,
        private errorHandler: ErrorHandlerService
    ) {
        super();
    }

    fetch(id: number): Observable<ItemInventarioResumido> {
        return this.httpClient.get<ItemInventarioResumido>(`/api/estoque/v1/itensInventario/${id}`)
                              .pipe(
                                catchError((err: any) => throwError(this.errorHandler.handle(err)))
                              );
    }

    // TODO porque o retorno deste observable esta tipado como any?
    list(idInventario: number, filter: ItemInventarioFilter, listComponent?: ListaComponent): Observable<any> {
        const params = DefaultServiceInterface.converterFiltroParaHttpParam(filter);
        return this.httpClient.get(`/api/estoque/v1/inventarios/${idInventario}/itensInventario`, {params})
        .pipe(
             catchError ( (err: any) => {
                throwError(this.errorHandler.handle(err));
                if (listComponent) {
                    listComponent.setLoading(false);
                    listComponent.hasError = true;
                }
                return empty();
            })
        );
    }

    adicionar(id: number, idInventario: number, quantidade: number): Observable<ItemInventarioResumido> {
        return this.httpClient.put<ItemInventarioResumido>(`/api/estoque/v1/inventarios/${idInventario}/itensInventario/${id}/adicionar`,
                    quantidade,
                    this.httpOptions)
                    .pipe(
                      catchError((err: any) => throwError(this.errorHandler.handle(err)))
                    );
    }

    remover(id: number, idInventario: number, quantidade: number): Observable<ItemInventarioResumido> {
        return this.httpClient.put<ItemInventarioResumido>(`/api/estoque/v1/inventarios/${idInventario}/itensInventario/${id}/remover`,
                    quantidade,
                    this.httpOptions)
                    .pipe(
                      catchError((err: any) => throwError(this.errorHandler.handle(err)))
                    );
    }

    inserir(itemInventario: ItemInventarioResumido): Observable<ItemInventarioResumido> {
        return this.httpClient.post<ItemInventarioResumido>(`/api/estoque/v1/inventarios/${itemInventario.idInventario}/itensInventario`,
                    itemInventario,
                    this.httpOptions)
                    .pipe(
                      catchError((err: any) => throwError(this.errorHandler.handle(err)))
                    );
    }

    excluir(id: number, idInventario: number): Observable<void> {
      return this.httpClient.delete<void>(`/api/estoque/v1/inventarios/${idInventario}/itensInventario/${id}`)
                            .pipe(
                              catchError((err: any) => throwError(this.errorHandler.handle(err)))
                            );
    }

    buscarItensInventario(itemInventarioFilter: ItemInventarioFilter): Observable<ListaResultset<ItemInventario>> {
      const params = DefaultService.converterFiltroParaHttpParam(itemInventarioFilter);

      return this.httpClient.get<ListaResultset<ItemInventario>>(`/api/estoque/v1/inventarios/itensInventario`, {params})
                            .pipe(
                              // map((result: ListaResultset<ItemInventario>) => {
                              //   result.content
                              //         .forEach(iinventarioDTO => {
                              //           const itensInventario = iinventarioDTO.itensInventario;
                              //           if ( itensInventario.length > 0 ) {
                              //             iinventarioDTO.unidade = itensInventario[0].lote.unidade;
                              //           }
                              //         });

                              //   return result;
                              // })
                              // ,
                              catchError ( (err: any) => {
                                throwError(this.errorHandler.handle(err));
                                return empty();
                              })
      );
    }

    listarItensInventario(itemInventarioFilter: ItemInventarioFilter): Observable<ListaResultset<InventarioDTO>> {
      const params = DefaultService.converterFiltroParaHttpParam(itemInventarioFilter);

      // const idUnidade = seletorDeLoteFilter.idUnidade;
      // const idProduto = seletorDeLoteFilter.idProduto;
      // const quantidadeMaiorQue = ( seletorDeLoteFilter.quantidadeMinima ? seletorDeLoteFilter.quantidadeMinima : 1 );
      // let _idUnidade = ( idUnidade ? idUnidade : '' );
      // return this.httpClient.get<ListaResultset<IInventarioDTO>>(`/api/estoque/v1/inventarios/itensInventario?idUnidade=${_idUnidade}&idProduto=${idProduto}&size=0&quantidadeMaiorQue=${quantidadeMaiorQue}`, {params})

      return this.httpClient.get<ListaResultset<InventarioDTO>>(`/api/estoque/v1/inventarios/itensInventario`, {params})
                            .pipe(
                              // map((result: ListaResultset<ItemInventario>) => {
                              //   result.content
                              //         .forEach(iinventarioDTO => {
                              //           const itensInventario = iinventarioDTO.itensInventario;
                              //           if ( itensInventario.length > 0 ) {
                              //             iinventarioDTO.unidade = itensInventario[0].lote.unidade;
                              //           }
                              //         });

                              //   return result;
                              // })
                              // ,
                              catchError ( (err: any) => {
                                throwError(this.errorHandler.handle(err));
                                return empty();
                              })
      );
    }
}
